export const UPDATE_FK_RATING_REQUEST = 'UPDATE_FK_RATING_REQUEST';

export const updateFkRatingRequest = ( resultIds = [], { ratingCode } ) => ({
  type: UPDATE_FK_RATING_REQUEST,
  payload: {
    resultIds,
    ratingCode
  }
});
